@if (isLoadingServices) {
  <div class="loading-indicator">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
} @else if (formRef && allServices.length > 0) {
  <div class="service-info-container mb-2 mt-6" [formGroup]="formRef">
    @if (allServices.length > 1) {
      <div class="font-lighter pt-6 font-montserrat text-base">
        Identify issue by:
      </div>
      <mat-radio-group
        class="default-contact-options"
        formControlName="identifyIssueBy"
        (change)="onServiceLocationRadioChange()"
      >
        <mat-radio-button
          class="service-location-radio"
          value="location"
          checked
        >
          <div class="icon-text text-base">
            <!-- <div class="custom-icon location"></div> -->
            <!-- <div class="custom-icon location_dark"></div> -->
            Service Location
          </div>
        </mat-radio-button>
        <mat-radio-button class="service-location-radio" value="service">
          <div class="icon-text text-base">
            <!-- <div class="custom-icon circuit"></div> -->
            <!-- <div class="custom-icon circuit_dark"></div> -->
            Service
          </div>
        </mat-radio-button>
      </mat-radio-group>
    }

    @if (this.formRef.value.identifyIssueBy === LOCATION) {
      <!---
      - if there is one location, there is only one service: display both static
      - if there is one location and multiple services: display location static and services as a dropdown
      - if there are many locations: display location dropdown and hide service information
      ---- choosing a location with one service: display service static
      ---- choosing a location with many services: display service dropdown -->
      @if (uniqueLocations.length === 1) {
        @if (allServices.length === 1) {
          <div class="display-static">
            <h3>Service:</h3>
            <div class="icon-text">
              <div class="custom-icon circuit_dark"></div>
              {{ allServices[0].Name }} – {{ allServices[0].RecordType.Name }}
            </div>
          </div>
        } @else {
          <div class="question mt-2">Which service?</div>
          <mat-form-field>
            <mat-label>Please select a service</mat-label>
            <mat-select
              formControlName="service"
              (valueChange)="onServiceSelected($event)"
            >
              @for (s of allServices; track s.Id) {
                <mat-option [value]="s.Id">
                  {{ s.Name }} – {{ s.RecordType.Name }}
                  @if (s.bandwidth) {
                    <span> - {{ s.bandwidth }}</span>
                  }
                  @if (s?.Vendor__r?.Display_Alias__c) {
                    <span> - {{ s?.Vendor__r?.Display_Alias__c }} </span>
                  }
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      } @else if (uniqueLocations.length > 1) {
        <div class="select-container">
          <app-autocomplete-location
            [allLocations]="uniqueLocations"
            (locationSelected)="locationSelected($event)"
          ></app-autocomplete-location>
          @if (servicesAtChosenLocation.length === 1) {
            <div class="display-static">
              <h3 class="my-1">Service associated:</h3>
              <div class="icon-text">
                <div class="custom-icon circuit_dark upper"></div>
                @if (servicesAtChosenLocation[0]) {
                  <ng-container>
                    {{
                      servicesAtChosenLocation[0].Name
                        ? servicesAtChosenLocation[0].Name
                        : ''
                    }}
                    -
                    {{
                      servicesAtChosenLocation[0].RecordType
                        ? servicesAtChosenLocation[0].RecordType.Name
                        : ''
                    }}
                  </ng-container>
                }
              </div>
            </div>
          } @else if (servicesAtChosenLocation.length > 1) {
            <div class="question mt-2">Which service?</div>
            <mat-form-field>
              <mat-label>Please select a service</mat-label>
              <mat-select
                formControlName="service"
                (valueChange)="onServiceSelected($event)"
              >
                @for (s of servicesAtChosenLocation; track s.Id) {
                  <mat-option [value]="s.Id">
                    {{ s.Name }} – {{ s.RecordType.Name }}
                    @if (s.Bandwidth_Text__c) {
                      <span> - {{ s.Bandwidth_Text__c }}</span>
                    }
                    @if (s?.Vendor__r?.Display_Alias__c) {
                      <span> - {{ s?.Vendor__r?.Display_Alias__c }}</span>
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      }
      @if (inlineErrors.service) {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ inlineErrors.service }}</div>
        </div>
      }
    } @else {
      <div>
        <!--
        - if there is one service, there is only one location: display both static
        - if there are multiple services: display services in a dropdown
        ---- after choosing a service, display the location static -->
        @if (allServices.length === 1) {
          <div class="question">Service:</div>
          {{ allServices[0].Name }} - {{ allServices[0].RecordType.Name }}
          <div class="question">Service location:</div>
          {{ allServices[0].Z_Location__r.Name }} –
          {{ allServices[0].RecordType.Name }}
        } @else if (allServices.length > 1) {
          <div class="select-container">
            <app-autocomplete
              [allServices]="allServices"
              [selectedServiceId]="selectedServiceId"
              [ticketType]="ticketType"
              [formRef]="formRef"
              [identifyIssueBy]="this.formRef.value.identifyIssueBy"
              (serviceSelected)="serviceSelected($event)"
            ></app-autocomplete>
          </div>
        }
        @if (inlineErrors.service) {
          <div class="form-error">
            <div class="custom-icon inline_error"></div>
            <div class="error-message">{{ inlineErrors.service }}</div>
          </div>
        }
      </div>
    }
  </div>
}
